/**
 * 8kHz mono s16le 播放端预加重（一阶），略提升高频感知，减轻「气音/齿音」发糊。
 * 无法恢复 Codec2 已丢失的频带，只做听感补偿；coeff 越大越亮，过大易噪/削波。
 */
export function applyCodec2Mono8kPreemphasisS16le(pcm: ArrayBuffer, coeff: number): ArrayBuffer {
  if (coeff <= 0 || pcm.byteLength < 2) {
    return pcm.byteLength ? pcm.slice(0) : pcm;
  }
  const n = Math.floor(pcm.byteLength / 2);
  const src = new Int16Array(pcm, 0, n);
  const out = new Int16Array(n);
  let prev = 0;
  const headroom = 0.93;
  for (let i = 0; i < n; i++) {
    const x = src[i];
    const y = (x - coeff * prev) * headroom;
    prev = x;
    const v = Math.round(y);
    out[i] = v < -32768 ? -32768 : v > 32767 ? 32767 : v;
  }
  return out.buffer.slice(out.byteOffset, out.byteOffset + out.byteLength);
}
